import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { LogService } from '../../../../core/services/log.service';
// import { EventGuestsService } from '../../services/event-guests.service';

import LaguagesEditPageView from "./languages-edit.page.html";

@Component({
    selector: 'languages-edit-page',
    template: LaguagesEditPageView
})

export class LanguagesEditPage implements OnInit {

    isAllowed: boolean = false;

    constructor(@Inject(AuthService) private authService: AuthService,
        @Inject(LogService) private log: LogService,
        @Inject('$stateParams') private $stateParams: any) {
    }

    ngOnInit() {
        this.isAllowed = this.authService.permissionExist('LANGUAGES_WRITE') ?? false;
    }

}